

export const addDonationWizardSteps = {
  donorDetails: 1,
  donationDetails: 2,
  paymentDetails: 3,
  confirmDonation: 4,
  donationAdded: 5,
};


export const purchaseTicketWizardSteps = {
  donorDetails: 1,
  ticketDetails: 2,
  guestInfo: 3,
  paymentDetails: 4,
};

export const donationTypes = {
  oneTime: 'one-time',
  recurring: 'recurring',
  roundUp: 'round-up',
  external: 'external',
};

export const donationTypesLabels = {
  'one-time': 'One Time',
  recurring: 'Recurring',
  'round-up': 'Round-Up',
  external: 'External',
};

export const paymentTypes = {
  card: 'card',
  cash: 'cash',
  check: 'check',
  ach: 'ach',
};

export const paymentTypesLabels = {
  card: 'Credit Card',
  cash: 'Cash',
  check: 'Check',
  ach: 'Bank Transfer',
};
